import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {
  UncontrolledTooltip,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
} from 'reactstrap';

import SurveyApi from 'apis/Survey';
import ToolTip from '../components/Tooltip';

class PlacardButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false,
    };
    this.toggle = this.toggle.bind(this);
    this.getSurveyPlacard = this.getSurveyPlacard.bind(this);
  }

  getSurveyPlacard(surveyId) {
    window.location.href = SurveyApi.getSurveyPlacard(surveyId);
  }

  toggle() {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  }

  render() {
    const { customSurvey, icon, title } = this.props;
    const { dropdownOpen } = this.state;
    const { survey_token, id } = customSurvey;
    const btnText = title || 'Placard';

    return (
      <Dropdown isOpen={dropdownOpen} toggle={this.toggle}>
        <DropdownToggle
          id={`pd${survey_token}`}
          className="btn-outline-secondary btn-sm mr-1 mb-1"
        >
          {icon && <FontAwesomeIcon icon="print" />}
          {btnText}
        </DropdownToggle>
        <ToolTip
          title={'Survey Placard'}
          placement="bottom"
          hidden={dropdownOpen}
          target={`pd${survey_token}`}
        />
        <DropdownMenu className="pl-2 pr-2" style={{ width: 180 }}>
          <DropdownItem header className="pl-0 pt-0 pb-0">
            Placard
          </DropdownItem>
          <div
            id={`dp${survey_token}`}
            className="custom-survey-promote-icon-container"
          >
            <a
              className="placard-download-button"
              onClick={() => this.getSurveyPlacard(id)}
            >
              <FontAwesomeIcon icon="download" size="xs" />
              Download
            </a>
            <UncontrolledTooltip
              placement="right"
              target={`dp${survey_token}`}
              className="custom-survey-icon-tool-tip"
            >
              Download Survey Placard
            </UncontrolledTooltip>
            {/* <a
              href="#"
              style={{ cursor: 'pointer' }}
              className="circular-icon custom-survey-promote-icon"
            >
              <FontAwesomeIcon
                id={`p${this.props.customSurvey.survey_token}`}
                icon="print"
                size="xs"
              />
            </a>
            <UncontrolledTooltip
              placement="bottom"
              target={`p${this.props.customSurvey.survey_token}`}
              style={{ fontSize: '9px' }}
            >
              Print Placard
            </UncontrolledTooltip> */}
          </div>
        </DropdownMenu>
      </Dropdown>
    );
  }
}

PlacardButton.propTypes = {
  customSurvey: PropTypes.object,
};

export default PlacardButton;



// WEBPACK FOOTER //
// ./src/utils/PlacardButton.js